import { Divider as CascadiaDivider } from "@certn/cascadia-react";
import { ArrayLayoutProps } from "@jsonforms/core";
import { getMinItems } from "../utils";

interface Props extends ArrayLayoutProps {
  index: number;
}

export function Divider(props: Props) {
  const minItems = getMinItems(props.minItems, props.uischema);

  if (
    (props.uischema.options?.showDivider && props.index > 0) ||
    (minItems !== 0 && props.index === minItems)
  ) {
    return <CascadiaDivider />;
  }
  return <></>;
}
